import ZalesFooter from "./zales"
import React from "react";

class GordonsJewelersFooter extends ZalesFooter {
    siteDomain = 'GORDONSJEWELERS.COM'

    getSocialIcons() {
        return null
    }
    getShopOutlet(){
        return (
               <div></div>
        )
    }
    getSocialIconsDiv() {
        return (
            <div>
      
            </div>
          
        )
    }


    
}

export default GordonsJewelersFooter



// WEBPACK FOOTER //
// ./src/site_interfaces/footers/gordonsjewelers.js